import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../libs/utils";
import { forwardRef } from "react";
export const Heading = forwardRef(({ className, level = 3, ...props }, ref) => {
    const Component = `h${level}`;
    const styles = {
        h1: "text-2xl font-medium tracking-tight",
        h2: "text-xl font-medium tracking-tight",
        h3: "text-lg font-medium",
        h4: "text-base font-medium",
        h5: "text-sm font-medium",
        h6: "text-xs font-medium",
    };
    return _jsx(Component, { ref: ref, className: cn(styles[`h${level}`], 'mb-2', className), ...props });
});
Heading.displayName = "Heading";
//# sourceMappingURL=heading.js.map